import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-a', 'IconCircleLetterA', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 16v-6a2 2 0 1 1 4 0v6', key: 'svg-1' }],
  ['path', { d: 'M10 13h4', key: 'svg-2' }],
]);
